import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AdminPulse from "@/pages/AdminPulse";
import AdminGate from "@/components/AdminGate";

export const Route = createFileRoute("/admin/pulse")({
  head: () => seoHead("/admin/pulse"),
  component: () => (
    <AdminGate><AdminPulse /></AdminGate>
  ),
});
